const ownLink = "https://opimisil.com/JRLtnPPf";

const blogs = [
  {
    id: 1,
    date: "10/01/2025",
    picture: {
      avif: "img/blog1.avif",
      webp: "img/blog1.webp",
      jpg: "img/blog1.jpg",
    },
    title: "Aproveite o Bônus e Descubra os Jogos Mais Populares de 2288bet9",
    descr:
      "Saiba como aproveitar ao máximo os bônus oferecidos pela 2288bet9 para explorar os jogos mais emocionantes.",
    fullText:
      "Os bônus são uma das principais atrações do 2288bet9 e podem transformar sua experiência de jogo.\n" +
      "Aproveite o bônus de boas-vindas para explorar uma ampla variedade de jogos disponíveis na plataforma.\n" +
      "Jogos populares como slots, blackjack e roleta são perfeitos para começar sua jornada.\n" +
      "Além disso, o bônus de recarga permite que você mantenha sua conta ativa com mais créditos para jogar.\n" +
      "Os jogadores também podem desfrutar de promoções especiais durante feriados e eventos exclusivos.\n" +
      "Certifique-se de ler os termos e condições para entender como retirar seus ganhos de bônus.\n" +
      "Use estratégias inteligentes para maximizar suas chances de sucesso com os bônus oferecidos.\n" +
      "Descubra como cada jogo oferece diferentes oportunidades para transformar bônus em prêmios reais.",
  },
  {
    id: 2,
    date: "08/01/2025",
    picture: {
      avif: "img/blog2.avif",
      webp: "img/blog2.webp",
      jpg: "img/blog2.jpg",
    },
    title: "Dicas para Ganhar Mais nos Jogos do 2288bet9",
    descr:
      "Estratégias e truques para aumentar suas chances de vitória nos jogos de cassino.",
    fullText:
      "Para ter sucesso nos jogos de cassino do 2288bet9, a preparação é essencial.\n" +
      "Conheça as regras de cada jogo antes de começar a apostar com dinheiro real.\n" +
      "Use os modos demo para praticar sem risco e entender as mecânicas de cada jogo.\n" +
      "Gerencie seu orçamento e defina limites para evitar gastos excessivos.\n" +
      "Fique de olho nas promoções e bônus disponíveis para maximizar seu saldo.\n" +
      "Nos jogos de mesa como blackjack e pôquer, aprenda estratégias básicas para aumentar suas chances.\n" +
      "Slots são ideais para diversão, mas escolha aqueles com RTP (Retorno ao Jogador) mais alto.\n" +
      "Mantenha a calma e jogue com responsabilidade para aproveitar a experiência ao máximo.",
  },
  {
    id: 3,
    date: "05/01/2025",
    picture: {
      avif: "img/blog3.avif",
      webp: "img/blog3.webp",
      jpg: "img/blog3.jpg",
    },
    title: "Novidades de Ano Novo: Bônus Agradáveis no 2288bet9",
    descr:
      "Confira as promoções exclusivas de Ano Novo para começar 2025 com sorte e prêmios.",
    fullText:
      "O Ano Novo é um momento perfeito para aproveitar os bônus especiais no 2288bet9.\n" +
      "Durante o período de festas, você encontrará promoções exclusivas para aumentar seu saldo.\n" +
      "Deposite e receba presentes incríveis que podem ser usados em todos os jogos.\n" +
      "As recompensas incluem rodadas grátis, cashback e muito mais.\n" +
      "Aproveite o bônus de recarga semanal para manter sua conta sempre ativa.\n" +
      "Participar de eventos temáticos de Ano Novo pode render prêmios adicionais.\n" +
      "Verifique as ofertas diárias para não perder nenhuma oportunidade de ganhar mais.\n" +
      "Comemore o Ano Novo jogando e ganhando prêmios do Papai Noel no 2288bet9.",
  },
  {
    id: 4,
    date: "02/01/2025",
    picture: {
      avif: "img/blog4.avif",
      webp: "img/blog4.webp",
      jpg: "img/blog4.jpg",
    },
    title: "Os Melhores Jogos para Iniciantes no 2288bet9",
    descr:
      "Descubra os jogos mais indicados para quem está começando no mundo dos cassinos.",
    fullText:
      "Se você é novo no 2288bet9, há muitos jogos perfeitos para iniciantes.\n" +
      "Slots são ideais, pois não exigem habilidades avançadas e oferecem diversão imediata.\n" +
      "Roleta é outro jogo simples com opções de aposta fáceis de entender.\n" +
      "Blackjack básico é uma excelente escolha para aprender as regras e estratégias do jogo.\n" +
      "Experimente os modos demo para ganhar confiança antes de apostar dinheiro real.\n" +
      "Aproveite os bônus de boas-vindas para explorar diferentes jogos sem gastar muito.\n" +
      "Participe de torneios para competir com outros jogadores e ganhar prêmios extras.\n" +
      "Leia dicas e tutoriais no blog para melhorar suas habilidades.\n" +
      "Jogue com responsabilidade e aproveite a experiência de forma divertida.",
  },
  {
    id: 5,
    date: "31/12/2024",
    picture: {
      avif: "img/blog5.avif",
      webp: "img/blog5.webp",
      jpg: "img/blog5.jpg",
    },
    title: "Como Participar de Promoções no 2288bet9",
    descr:
      "Saiba como se inscrever e aproveitar as promoções exclusivas da plataforma.",
    fullText:
      "Participar de promoções no 2288bet9 é simples e pode trazer grandes benefícios.\n" +
      "Acesse a seção de promoções no site para ver as ofertas disponíveis.\n" +
      "Leia os detalhes de cada promoção para entender os requisitos e prêmios.\n" +
      "Cadastre-se e faça seu primeiro depósito para desbloquear o bônus de boas-vindas.\n" +
      "Use códigos promocionais exclusivos para acessar ofertas especiais.\n" +
      "Participe de eventos temáticos para ganhar prêmios sazonais e exclusivos.\n" +
      "Mantenha-se atualizado sobre promoções semanais e diárias no blog.\n" +
      "Compartilhe suas experiências com outros jogadores para dicas e estratégias adicionais.\n" +
      "Com as promoções do 2288bet9, cada aposta é uma chance de ganhar mais.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
